<div class="container">
  <div>
    <h1>{{ "migration.intro.title" | translate }}</h1>

    <p class="message">
      {{ "migration.intro.message" | translate }}
      <br/>
      {{ "migration.intro.howItWorks" | translate }}
    </p>
  </div>

  <img src="assets/images/Anim_Asset_blueprint.gif" />

  <div class="footer">
    <div class="blueprints">
      <h3 class="sub-title"><span class="step-number">1</span> {{ "migration.intro.blueprint.prefix" | translate }} <strong>{{ "migration.intro.blueprint.bold" | translate }}</strong></h3>
      <p>{{ "migration.intro.blueprint.description" | translate }}</p>
    </div>
    <div class="assets">
      <h3 class="sub-title"><span class="step-number">2</span> {{ "migration.intro.assets.prefix" | translate }} <strong>{{ "migration.intro.assets.bold" | translate }}</strong></h3>
      <p>{{ "migration.intro.assets.description" | translate }}</p>
    </div>
  </div>
</div>
